export default __webpack_public_path__ + "static/media/about-left.a0fffed9.jpg";